
<template>
  <div class="formgroup">
    <drag-modal :visible="visible" @cancel="visible=false" title='表单导出' width='400px'>
      <ul class="uls">
        <li v-if='$common.AUTH("export:fqxxb")'>
          分期信息表<a-button size="small" icon="download" style="height:28px;" @click="out(1)">导出</a-button>
        </li>
        <li v-if='$common.AUTH("export:hkxxb")'>
          回款信息表<a-button size="small" icon="download" style="height:28px;" @click="out(2)">导出</a-button>
        </li>
        <!-- <li v-if='$common.AUTH("export:dqjdb")'>
          当前进度表<a-button size="small" icon="download" style="height:28px;" @click="out(3,true)">导出</a-button>
        </li> -->
        <li v-if='$common.AUTH("export:lsjdb")'>
          历史进度表<a-button size="small" icon="download" style="height:28px;" @click="out(4,true)">导出</a-button>
        </li>
        <li v-if='$common.AUTH("export:cpwsb")'>
          裁判文书表<a-button size="small" icon="download" style="height:28px;" @click="out(5)">导出</a-button>
        </li>
        <li v-if='$common.AUTH("export:ssxxzb")'>
          案件信息总表 <a-button size="small" icon="download" style="height:28px;" @click="out(0)">导出</a-button>
        </li>
        <li v-if='$common.AUTH("export:cpjladlrb")'>
          传票及立案代理人表<a-button size="small" icon="download" style="height:28px;" @click="out(6)">导出</a-button>
        </li>
        <li v-if='$common.AUTH("export:ssdlfyjnjtfb")'>
          案件代理费用缴纳及退费表<a-button size="small" icon="download" style="height:28px;" @click="out(7)">导出</a-button>
        </li>
      </ul>
    </drag-modal>
    <a-row class="row" :gutter="40">
      <a-col :span='5' class="flex" >
        <label>委托类型：</label>
        <a-select placeholder="请选择" class="select">
          <a-select-option :value="1">委托代理</a-select-option>
          <a-select-option :value="2">委托管理</a-select-option>
        </a-select>
      </a-col>
      <a-col :span='6' class="flex" >
        <label style="width: 130px;text-align: right;">案件类型：</label>
        <a-select v-model="form.cause_type" placeholder="请选择"  class="select">
          <!-- <a-select-option :value="0" disabled>调解</a-select-option> -->
          <a-select-option :value="2">调解</a-select-option>
          <a-select-option :value="1">诉讼</a-select-option>
          <a-select-option :value="3" disabled>公证执行</a-select-option>
        </a-select>
      </a-col>
  
      <a-col :span='6' class="flex">
        <label>原告：</label>
        <a-select class="select"  v-model="form.accuser_id" placeholder="请选择"  mode="multiple" :maxTagCount='1' :maxTagTextLength='12' @change="ckAcc" allowClear :filter-option="$common.filterOption">
          <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id">{{ item.title }}</a-select-option>
        </a-select>
      </a-col>
      <a-col :span='6' class="flex">
        <label>管辖法院：</label>
        <a-select  class="select" v-model="form.court_id" placeholder="请选择"   mode="multiple" :maxTagCount='1' :maxTagTextLength='14' @search="handleSearch" :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null" allowClear>
          <a-select-option v-for="item in courtList" :key="item.title" :value="item.id">{{ item.title }}</a-select-option>
        </a-select>
      </a-col>
    
    </a-row>
    <a-row class="row" :gutter="40">
      <!-- <a-col :span="5" class="flex">
        <label>贷款机构：</label>
        <a-select  class="select" v-model="form.bank_id" placeholder="请选择"  :maxTagCount='1' :maxTagTextLength='5' :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null" allowClear>
          <a-select-option v-for="item in bank" :key="item.title" :value="item.id">{{ item.title }}</a-select-option>
        </a-select>
      </a-col> -->
      <a-col :span="5" class="flex">
        <label>统计类型：</label>
        <a-select  class="select" v-model="ckType" placeholder="请选择" >
          <a-select-option :value="2">当前进度</a-select-option>
          <a-select-option :value="1">历史进度</a-select-option>
        </a-select>
      </a-col> 
      <a-col :span="6" class="flex">
        <label>案件录入日期：</label>
        <!-- <a-range-picker v-model='time' valueFormat="YYYY-MM-DD" @change="PickTime" /> -->
        <timePick @PickTime="PickTime"></timePick>
      </a-col>
      <!-- <a-col :span="7" class="flex">
        <label>开庭时间：</label>
        <timePick @PickTime="PickOpen"></timePick>
      </a-col> -->
      
      <a-col :span="8" class="flex">
        <a-button icon="search" type='primary' style="height:32px;" @click='search()'>查询</a-button>
        <a-button style="height:32px;margin-left: 20px;" @click='reset'>重置</a-button>
        <a-button icon="upload" type='primary' ghost style="height:32px;margin-left:20px;" @click="out(3)" v-if='$common.AUTH("export:lsjdb") && ckType==1'>导出</a-button>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { getAccuserAll, reasonList } from '@/server/api'
import { getDirectory, bankList } from "@/server/directory"
import { mapGetters } from 'vuex'
import { exportForm } from '@/assets/js/unit'
export default {
  data() {
    return {
      visible: false,
      cause_reason: [],  //案由
      accuserList: [],
      courtList: [],
      bank: [],
      ckType:2,
      form: {
        cause_type:1,
        bank_id: '',
        reason_id: [],
        accuser_id: [],
        debtor_stime: '',
        car_type_id: undefined,
        debtor_etime: '',
        // open_stime: '',
        // open_etime: '',
        court_id: [],
        ja_state: undefined,
        is_same_accuser: undefined,
        cause_status: undefined,
        cause_step: undefined,
        is_role_exact: undefined,
        team_id: '',
        cause_is_complete: undefined,
        loan_status: []
      }
    }
  },
  computed: {
    ...mapGetters([
      'APIKEY'
    ]),
    teamList() {
      return this.form.accuser_id.length > 1 || this.form.accuser_id.length == 0 ? [] : this.accuserList.find(ele => {
        return ele.id === this.form.accuser_id[0]
      }).team
    }
  },
  created() {
    bankList({limit:100}).then(e => {
      this.bank = e.list
    })
    reasonList().then(e => {
      this.cause_reason = e.list
    })
    getAccuserAll().then((res) => {
      this.accuserList = res.list
    })
    this.handleSearch('')
  },
  methods: {
    handleSearch(val) {
      getDirectory({ limit: 100, title: val }).then((res) => {
        this.courtList = res.list
      })
    },
    ckAcc(val) {
      if (val.length > 1 || val.length == 0) {
        this.form.team_id = ''
      }
    },
    PickTime(e) {
      if ("stime" in e) {
        this.form.debtor_stime = e.stime
      }
      else {
        this.form.debtor_etime = e.etime
      }
    },
    PickOpen(e) {
      if ("stime" in e) {
        this.form.open_stime = e.stime
      }
      else {
        this.form.open_etime = e.etime
      }
    },
    ckStatus(e) {
      if (e.length > 1) {
        this.form.team_id = ''
      }
    },
    search() {
      this.$emit('search', this.form,this.ckType)
    },
    reset(){
      this.form.cause_type = undefined
      this.form.accuser_id = []
      this.form.court_id = []
      this.ckType = 2
      this.search()
    },
    out(type) {
      const form = JSON.parse(JSON.stringify(this.form));
      form.step = this.$parent.stepCode.toString()
      exportForm(type,form)      
    }
  }
}
</script>
<style lang="less" scoped>
@import url('@/assets/css/search.less');
.uls {
  li {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
  }
}

</style>